import React, {createContext, useEffect, useState} from 'react';
import './App.css';
import {theme} from "./Tema";
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import {ThemeProvider} from "@mui/system";
import {useEscucharAuth} from "./Servicios/Auth/Hooks/useEscucharAuth";
import Login from "./Login/Login";
import logo from './Recursos/logo_blanco.svg'
import logoRedondo from './Recursos/logo_redondo.svg'
import {Grid} from "@mui/material";
import Dashboard from "./Dashboard/Dashboard";
import {useEscucharUsuarioToCorreoBitNova} from "./CodigoCliente/Cuentas/useEscucharUsuarioToCorreoBitNova";
import {useCargador} from "./Modulo_Cargador/Hooks/useCargador";


export const usuarioContext = createContext();

function App() {
    const {email, data, verificando} = useEscucharAuth()
    const [codigo, setCodigo] = useState('')
    const {usuario, verificando: verificandoUsuario,setUsuario } = useEscucharUsuarioToCorreoBitNova({
        correo: email,
        user: data,
        codigo: codigo
    })
    const {Cargador, Avisos, iniciarCarga, terminar, cerrarCarga} = useCargador({logoRedondo: logoRedondo})


    const valoresProvider = {
        usuario,
        setUsuario,
    }

    const {Provider} = usuarioContext;


    useEffect(() => {


        if (window.swUpdateReady) {
            window.swUpdateReady = false;
            window.stop();
            window.location.reload();
        }


    }, [])

    useEffect(() => {

        if (verificandoUsuario) {
            iniciarCarga('Verificando datos')
        } else {
            cerrarCarga()
        }

    }, [verificandoUsuario]);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Provider value={valoresProvider}>
                {usuario ?
                    <ThemeProvider theme={theme}>
                        <Dashboard/>
                    </ThemeProvider>

                    :
                    <Login logo={logo} setCodigo={setCodigo} codigo={codigo}/>
                }

            </Provider>
        </Grid>
    );
}

export default App;
